import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showMessage } from './snackBarActions'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ showMessage }, dispatch);

export default connect(null, mapDispatchToProps)


// WEBPACK FOOTER //
// ./src/store/snackbar/withSnackBar.js